import { useTypedQuery } from "hooks";
import { FactoryExportsDashboardQueryKeys } from "modules/FactoryExportsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DropdownItemProps } from "components";
import type { FactoryReport } from "models";

const formatReports = (reports: FactoryReport[]): DropdownItemProps[] => reports.map(({ id, name }) => ({ key: id, value: id, text: name }));

export const useReportsQuery = () =>
  useTypedQuery({
    queryKey: FactoryExportsDashboardQueryKeys.reports,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.get(endpoint, baseUrl)).data.reports,
    select: formatReports
  });
